import React from 'react';
import { ToastContainer } from 'react-toastify';
import Routers from './Routes';
import { AuthProvider } from './Components/Pages/Others/Authentication/Authcontext/AuthContext';


function App() {
  return (
    <AuthProvider>
      <Routers />
      <ToastContainer limit={1} />
    </AuthProvider>
  );
}

export default App;
